import { INITIALIZE_FORM_TERMS } from '../actionTypes';
import { companyGeneralActions } from '../reducer';

export default (values) => companyGeneralActions[INITIALIZE_FORM_TERMS](values);
